import React from 'react'
import ResultsSection, { NotAvailable } from './ResultsSection'
import useCareerExploration from './CareerExplorationProvider'

const RelatedOccupationsSection = ({ career, showSalaryData, ...props }) => {
  const { related } = career
  if (!related.length) {
    return (
      <NotAvailable section="related_occupations" career={career} {...props} />
    )
  }

  return (
    <ResultsSection section="related_occupations" career={career} {...props}>
      {showSalaryData ? (
        <div className="flex flex-col gap-2">
          {related.map((relatedItem, idx) => (
            <RelatedOccupation
              key={`related-occupation${idx}`}
              relatedItem={relatedItem}
              showSalaryData={true}
            />
          ))}
        </div>
      ) : (
        <ul className="list-disc pl-6">
          {related.map((relatedItem, idx) => (
            <li key={`related-occupation${idx}`}>
              <RelatedOccupation
                relatedItem={relatedItem}
                showSalaryData={false}
              />
            </li>
          ))}
        </ul>
      )}
    </ResultsSection>
  )
}

export default RelatedOccupationsSection

const RelatedOccupation = ({ relatedItem, showSalaryData }) => {
  const { formatMoneyAmt } = useCareerExploration()
  const { salary, path_url, name } = relatedItem
  return (
    <div>
      {showSalaryData && (
        <>
          {formatMoneyAmt(salary)} - <a href={path_url}>{name}</a>
        </>
      )}
      {!showSalaryData && <a href={path_url}>{name}</a>}
    </div>
  )
}
